/* eslint-disable react-hooks/rules-of-hooks */
import React, { useState, useEffect } from 'react';
import './style.css';
import { Layout, Button, DatePicker, Card, Progress } from 'antd';
import { PrinterOutlined } from "@ant-design/icons";
import axios from 'axios';
import { useCookies } from 'react-cookie';
import {Env, PrintFonts} from './../../../styles';
import dayjs from 'dayjs';
import AppTable from "../../atoms/AppTable";


const { RangePicker } = DatePicker;
export default function transferTable(props){
      const [cookies]=useCookies(["userId"]);
      const [filteredInfo,setFilteredInfo]=useState({});
      const [sortedInfo,setSortedInfo]=useState({});
      const [data,setData]=useState([]);
      const [load,setLoad]=useState(true);
      const [total,setTotal]=useState(0);
      const [requiredCount, setRequiredCount] = useState(0);
      const [actualCount, setActualCount] = useState(0);
      // IMPORTANT: keep start/end as strings (YYYY-MM-DD) to avoid passing dayjs objects to API URLs
      const [start,setStart]=useState(
        dayjs(
          dayjs().format('YYYY-MM')+"-"+props.setting.filter((item)=> item.key === "admin.month_start")[0]?.value,
          'YYYY-MM-DD'
        ).subtract(1, 'months').format('YYYY-MM-DD')
      );
      const [end,setEnd]=useState(
        dayjs(
          dayjs().format('YYYY-MM')+"-"+props.setting.filter((item)=> item.key === "admin.month_end")[0]?.value,
          'YYYY-MM-DD'
        ).format('YYYY-MM-DD')
      );
      // const [currentMonth,setCurrentMonth]=useState(dayjs().format('MMMM'));   
     
     // eslint-disable-next-line react-hooks/rules-of-hooks
     useEffect(() => {
        const id=cookies.user;
        if (!id?.user_id) return;
        setLoad(true);
        const startStr = dayjs(start).isValid() ? dayjs(start).format('YYYY-MM-DD') : start;
        const endStr = dayjs(end).isValid() ? dayjs(end).format('YYYY-MM-DD') : end;

        axios
          .get(Env.HOST_SERVER_NAME+'transport-amounts/'+id.user_id+'/'+startStr+'/'+endStr)
          .then(response => {
            const records = response.data.records || [];
            setData(records);

            let tot = 0.0;
            for (let i = 0; i < records.length; i++) {
              tot += parseFloat(records[i].transfer_value);
            }
            setTotal(tot);
            setRequiredCount(Number(response.data.requiredCount) || 0);
            setActualCount(
              Number(response.data.actualCount) || records.length || 0,
            );
          })
          .catch(function (error) {
            console.log(error);
          })
          .finally(() => {
            setLoad(false);
          });
       }, [start, end, cookies.user]);

    const handleChange = (pagination, filters, sorter) => {
        setFilteredInfo(filters);
        setSortedInfo(sorter);
      };
      const changeRange=(all,date)=>{
        //const id=cookies.user;
        setLoad(true);
        setStart(date?.[0] ? dayjs(date[0]).format('YYYY-MM-DD') : start);
        setEnd(date?.[1] ? dayjs(date[1]).format('YYYY-MM-DD') : end);
      }
    const columns = [
      {
        title: 'اليوم',
        dataIndex: 'dayName',
        key: 'dayName',
        filters: [
          { text: 'Joe', value: 'Joe' },
          { text: 'Jim', value: 'Jim' },
        ],
        filteredValue: filteredInfo.dayName || null,
        onFilter: (value, record) => record.dayName.includes(value),
        sorter: (a, b) => a.dayName.length - b.dayName.length,
        sortOrder: sortedInfo.columnKey === 'dayName' && sortedInfo.order,
        ellipsis: true,
      },
      {
        title: 'التاريخ',
        dataIndex: 'date',
        key: 'date',
        sorter: (a, b) => a.date - b.date,
        sortOrder: sortedInfo.columnKey === 'date' && sortedInfo.order,
        ellipsis: true,
      },
      {
        title: 'المستحق اليومي',
        dataIndex: 'transfer_value',
        key: 'transfer_value',
        sorter: (a, b) => a.transfer_value - b.transfer_value,
        sortOrder: sortedInfo.columnKey === 'transfer_value' && sortedInfo.order,
        ellipsis: true,
      },     
      
    ];
    const onChange=(all,data)=>{
      // setCurrentMonth(all.format('MMMM'));
  
      var startDay=props.setting.filter((item)=> item.key === "admin.month_start")[0]?.value;
      var endDay=props.setting.filter((item)=> item.key === "admin.month_end")[0]?.value;
  
      setStart(dayjs(data+"-"+startDay, 'YYYY-MM-DD').subtract(1, 'months').format('YYYY-MM-DD'));
      setEnd(dayjs(data+"-"+endDay, 'YYYY-MM-DD').format('YYYY-MM-DD'));
  
      }

      const printReport = () => {
        var report = document.getElementById("att-report");
        var mywindow = window.open("");
        mywindow.document.write(
          "<html><head><title></title> <style>" +
          PrintFonts.getPrintFontsCSS() +
          "body{font-size:12px;margin:0} " +
          "</style>"
        );
        mywindow.document.write('</head><body dir="rtl" style="font-size:12px;" >');
        mywindow.document.write(report.innerHTML);
        mywindow.document.write("</body></html>");
    
        mywindow.document.close();
        mywindow.onload = function () {
          mywindow.focus();
          mywindow.print();
        };
      };

const progressPercent = requiredCount > 0
  ? Math.min(100, Math.round((actualCount / requiredCount) * 100))
  : 0;

return (
    <Layout className="transfer">
    <Card bordered>
    <div className="transHeader">
      <div className="transPer">
        <span>
          <Progress
            type="circle"
            percent={progressPercent}
            width={window.innerWidth <= 760 ? 60 : 70}
            style={{ marginLeft: "5px", display: "inline-block" }}
          />
        </span>
        <span className="transPerText">
          <div style={{ marginBottom: "5px" }}>
            الدوام المطلوب : <span>{requiredCount}</span> يوم{" "}
          </div>
          <div>
            الدوام الفعلي : <span>{actualCount}</span> يوم{" "}
          </div>
        </span>
      </div>

      <div className="transOper">
        {window.innerWidth <= 760 ? (
          <></>
        ) : (
          <div className="transOperMonth">
            <span>اختر شهرًا : </span>
            <DatePicker
              needConfirm={false}
              inputReadOnly={window.innerWidth <= 760}
              defaultValue={dayjs()}
              onChange={onChange}
              picker="month"
            />
          </div>
        )}

        <div className="transOperRange">
          <span>اختر فترة : </span>
          <RangePicker
            needConfirm={true}
            inputReadOnly={window.innerWidth <= 760}
            format="YYYY-MM-DD"
            value={[dayjs(start, "YYYY-MM-DD"), dayjs(end, "YYYY-MM-DD")]}
            onChange={changeRange}
          />
        </div>

        <div className="transOperBtn">
          <Button
            disabled={load}
            onClick={printReport}
            type="primary"
            icon={<PrinterOutlined />}
            className="transPrintBtn"
          />
        </div>
      </div>
    </div>

    <div className="transSummaryBar">
      <div className="transSummaryItem">
        <div className="transSummaryLabel">المستحق اليومي</div>
        <div className="transSummaryValue">{data[0]?.transfer_value || 0} ر.ي</div>
      </div>
      <div className="transSummaryDivider" />
      <div className="transSummaryItem">
        <div className="transSummaryLabel">إجمالي المستحق</div>
        <div className="transSummaryValue transSummaryValue--red">{total} ر.ي</div>
      </div>
    </div>
    <AppTable
      loading={load}
      columns={columns}
      scroll={{ x: "1000px" }}
      dataSource={data}
      rowKey={(row, index) =>
        row?.date ? String(row.date) : `transfer-row-${index}`
      }
      onChange={handleChange}
      onRow={(record) => ({ className: record.status })}
    />
    </Card>
    
    <div id="att-report" style={{ display: "none" }}>
      <div style={{ direction: "rtl", fontSize: "12px", fontFamily: "Tajawal, sans-serif" }}>
        <table style={{ fontSize: "11px", width: "100%", textAlign: "center", borderCollapse: "collapse" }}>
          <thead>
            <tr>
              <th colSpan={4}>
                <header style={{ display: "flex", flexDirection: "row", borderBottom: "1px solid #000", paddingBottom: "10px", marginBottom: "15px" }}>
                  <div style={{ width: "20%", textAlign: "right" }}>
                    <img
                      loading="eager"
                      style={{ width: "220px" }}
                      src={Env.HOST_SERVER_STORAGE + props.setting.filter((item) => item.key === "admin.logo")[0]?.value}
                      alt="Logo"
                    />
                  </div>
                  <div style={{ width: "60%", textAlign: "center", display: "flex", flexDirection: "column", justifyContent: "center" }}>
                    <h1 style={{ fontSize: "20px", fontWeight: 700, margin: "0 0 5px 0" }}>كشف طلبات المواصلات</h1>
                    <h2 style={{ fontSize: "14px", fontWeight: 200, margin: "0" }}>للفترة من {start} إلى {end}</h2>
                  </div>
                  <div style={{ width: "20%", textAlign: "left", fontSize: "10px", display: "flex", flexDirection: "column", justifyContent: "center" }}>
                    <div>تاريخ الطباعة: {dayjs().format('YYYY-MM-DD')}</div>
                  </div>
                </header>
                
                <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "15px", backgroundColor: "#f9f9f9", padding: "10px", border: "1px solid #ddd", borderRadius: "5px" }}>
                  <div style={{ textAlign: "right", width: "50%" }}>
                    <div style={{ fontWeight: "bold" }}>الاسم: <span style={{ fontWeight: "normal" }}>{cookies.user?.name}</span></div>
                    <div style={{ fontWeight: "bold" }}>الوظيفة: <span style={{ fontWeight: "normal" }}>{cookies.user?.job}</span></div>
                  </div>
                  <div style={{ textAlign: "left", width: "50%", display: "flex", justifyContent: "space-around" }}>
                    <div style={{ textAlign: "center" }}>
                      <div style={{ color: "#8c8c8c", fontSize: "10px" }}>المطلوب</div>
                      <div style={{ fontWeight: "bold" }}>{requiredCount} يوم</div>
                    </div>
                    <div style={{ textAlign: "center" }}>
                      <div style={{ color: "#8c8c8c", fontSize: "10px" }}>الفعلي</div>
                      <div style={{ fontWeight: "bold" }}>{actualCount} يوم</div>
                    </div>
                    <div style={{ textAlign: "center" }}>
                      <div style={{ color: "#8c8c8c", fontSize: "10px" }}>إجمالي المستحق</div>
                      <div style={{ fontWeight: "bold", color: "#f5222d" }}>{total} ر.ي</div>
                    </div>
                  </div>
                </div>
              </th>
            </tr>
            <tr style={{ color: "#fff", backgroundColor: "#0972B6", height: "35px" }}>
              <th style={{ border: "1px solid #000", fontWeight: "100" }}>م</th>
              <th style={{ border: "1px solid #000", fontWeight: "100" }}>اليوم</th>
              <th style={{ border: "1px solid #000", fontWeight: "100" }}>التاريخ</th>
              <th style={{ border: "1px solid #000", fontWeight: "100" }}>المستحق اليومي</th>
            </tr>
          </thead>
          <tbody>
            {data.map((row, idx) => (
              <tr key={idx} style={{ height: "35px", backgroundColor: idx % 2 === 0 ? "#fff" : "#e6e6e6" }}>
                <td style={{ border: "1px solid #000" }}>{idx + 1}</td>
                <td style={{ border: "1px solid #000" }}>{row.dayName}</td>
                <td style={{ border: "1px solid #000" }}>{row.date}</td>
                <td style={{ border: "1px solid #000" }}>{new Intl.NumberFormat("en-EN").format(row.transfer_value)}</td>
              </tr>
            ))}
          </tbody>
          <tfoot>
            <tr style={{ height: "40px", backgroundColor: "#0972B6", color: "#fff", fontWeight: "bold" }}>
              <td colSpan="3" style={{ border: "1px solid #000", paddingRight: "15px", textAlign: "right" }}>إجمالي المبلغ المستحق :</td>
              <td style={{ border: "1px solid #000" }}>{new Intl.NumberFormat("en-EN").format(total)} ر.ي</td>
            </tr>
          </tfoot>
        </table>
        
        <div style={{ marginTop: "30px", display: "flex", justifyContent: "space-between", padding: "0 50px" }}>
          <div style={{ textAlign: "center" }}>
            <div style={{ fontWeight: "bold", marginBottom: "40px" }}>توقيع الموظف</div>
            <div style={{ borderBottom: "1px solid #000", width: "150px" }}></div>
          </div>
          <div style={{ textAlign: "center" }}>
            <div style={{ fontWeight: "bold", marginBottom: "40px" }}>المسؤول المباشر</div>
            <div style={{ borderBottom: "1px solid #000", width: "150px" }}></div>
          </div>
          <div style={{ textAlign: "center" }}>
            <div style={{ fontWeight: "bold", marginBottom: "40px" }}>اعتماد المدير</div>
            <div style={{ borderBottom: "1px solid #000", width: "150px" }}></div>
          </div>
        </div>
      </div>
    </div>
    </Layout>
);
    
 }
